var d=Object.defineProperty;var e=(b,a)=>d(b,"name",{value:a,configurable:!0});var f=b=>a=>{var c=b[a];if(c)return c();throw new Error("Module not found in bundle: "+a)};export{e as a,f as b};
//# sourceMappingURL=chunk-RPAKKUMI.mjs.map